import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle, XCircle } from '@phosphor-icons/react';
import SEO from '../components/SEO';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const VerifyEmail = () => {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) { setStatus('error'); setMessage('No verification token provided'); return; }
    axios.post(`${API}/auth/verify-email?token=${token}`)
      .then(r => { setStatus('success'); setMessage(r.data.message); })
      .catch(e => { setStatus('error'); setMessage(e.response?.data?.detail || 'Verification failed'); });
  }, [token]);

  return (
    <>
      <SEO title="Verify Email" description="Verify your Beyond Ball India email address." path="/verify-email" />
      <div className="min-h-screen flex items-center justify-center px-4 py-24 court-pattern">
        <div className="max-w-md w-full bg-white border border-gray-200 rounded-2xl p-8 shadow-sm text-center animate-fade-up">
          {status === 'verifying' && <><div className="text-gray-700 text-lg font-semibold mb-2">Verifying your email…</div><div className="text-gray-500 text-sm">One moment.</div></>}
          {status === 'success' && (
            <>
              <CheckCircle size={56} weight="fill" className="text-green-500 mx-auto mb-4" />
              <h1 className="text-2xl font-bold text-gray-900 mb-2">Email verified</h1>
              <p className="text-gray-600 mb-6 text-sm">{message}</p>
              <Link to="/dashboard" className="btn-primary inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold" data-testid="go-to-dashboard-link">Go to dashboard</Link>
            </>
          )}
          {status === 'error' && (
            <>
              <XCircle size={56} weight="fill" className="text-red-500 mx-auto mb-4" />
              <h1 className="text-2xl font-bold text-gray-900 mb-2">Verification failed</h1>
              <p className="text-gray-600 mb-6 text-sm">{message}</p>
              <Link to="/login" className="btn-primary inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold">Back to login</Link>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default VerifyEmail;
